import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a372dd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-btns" }
const _hoisted_2 = {
  key: 0,
  class: "btn-ticket"
}
const _hoisted_3 = { class: "btn-delete" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-delete" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "删除热点网格", -1))
const _hoisted_6 = { class: "content-block" }
const _hoisted_7 = { class: "content-top" }
const _hoisted_8 = { class: "top-row" }
const _hoisted_9 = { class: "top-item item-big" }
const _hoisted_10 = { class: "top-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "经纬度：", -1))
const _hoisted_12 = { class: "item-value" }
const _hoisted_13 = { class: "top-row" }
const _hoisted_14 = { class: "top-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "监测因子：", -1))
const _hoisted_16 = { class: "item-value" }
const _hoisted_17 = { class: "top-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "浓度：", -1))
const _hoisted_19 = { class: "item-value" }
const _hoisted_20 = { class: "content-tabs" }
const _hoisted_21 = { class: "content-table" }
const _hoisted_22 = {
  key: 0,
  class: "no-data empty"
}
const _hoisted_23 = {
  key: 1,
  class: "no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popconfirm = _resolveComponent("Popconfirm")!
  const _component_Table = _resolveComponent("Table")!
  const _component_gridHistory = _resolveComponent("gridHistory")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!
  const _component_ticketModal = _resolveComponent("ticketModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gridDetailContainer',_ctx.clickActive ? 'active' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.ticketDetail && Object.keys(_ctx.ticketDetail).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.ticketBtnText), 1))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "btn-ticket",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTicketDialog(null,null)))
          }, _toDisplayString(_ctx.ticketBtnText), 1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Popconfirm, {
          placement: "topRight",
          overlayClassName: "delete-pop grid-pop",
          title: "您确定删除该热点网格吗？",
          "ok-text": "确定",
          "cancel-text": "取消",
          onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deletHotGrid()))
        }, {
          icon: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.gridDetailData.zhen), 1),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.gridDetailData.lon) + " " + _toDisplayString(_ctx.gridDetailData.lat), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.polutionTypes[_ctx.gridDetailData.feature] || ''), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.gridDetailData.value) + "μg/m³", 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          class: _normalizeClass(['tab-btn',_ctx.activeTab === 1 ? 'active' :'']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClickTab(1)))
        }, " 疑似企业 ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(['tab-btn',_ctx.activeTab === 2 ? 'active' :'']),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClickTab(2)))
        }, " 近三个月超标情况 ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(['tab-btn',_ctx.activeTab === 3 ? 'active' :'']),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClickTab(3)))
        }, " 工单详情 ", 2)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_Table, {
              columns: _ctx.companyColumns,
              scroll: {y:150},
              "data-source": _ctx.companyTableData,
              rowKey: "id",
              pagination: false
            }, {
              index: _withCtx(({ index }) => [
                _createElementVNode("span", null, _toDisplayString(index+1), 1)
              ]),
              percentage: _withCtx(({ text }) => [
                _createElementVNode("span", null, _toDisplayString(text||text === 0?(text * 100).toFixed(0) : '--') + _toDisplayString(text||text===0?'%':''), 1)
              ]),
              _: 1
            }, 8, ["columns", "data-source"]), [
              [_vShow, _ctx.activeTab === 1]
            ]),
            _withDirectives(_createVNode(_component_Table, {
              columns: _ctx.exceedColumns,
              "data-source": _ctx.exceedTableData,
              scroll: { y: 150 },
              rowKey: "id",
              pagination: false
            }, {
              index: _withCtx(({ index }) => [
                _createElementVNode("span", null, _toDisplayString(index+1), 1)
              ]),
              issue: _withCtx(({ text,}) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.moment(text, 'YYYYMMDDHH').format('YYYY-MM-DD HH:00')), 1)
              ]),
              _: 1
            }, 8, ["columns", "data-source"]), [
              [_vShow, _ctx.activeTab === 2]
            ]),
            (_ctx.activeTab === 1 && !_ctx.companyTableData?.length || _ctx.activeTab === 2 && !_ctx.exceedTableData?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", null, [
              (_ctx.ticketDetail && Object.keys(_ctx.ticketDetail).length > 0)
                ? (_openBlock(), _createBlock(_component_gridHistory, {
                    key: 0,
                    ticketDetail: _ctx.ticketDetail
                  }, null, 8, ["ticketDetail"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_23))
            ], 512), [
              [_vShow, _ctx.activeTab === 3]
            ])
          ]),
          _: 1
        }, 8, ["locale"])
      ])
    ]),
    _createVNode(_component_ticketModal, {
      ticketModalVisible: _ctx.ticketModalVisible,
      "onUpdate:ticketModalVisible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ticketModalVisible) = $event)),
      selectOrderCode: _ctx.selectOrderID,
      action: _ctx.ticketModalAction,
      hotGridId: _ctx.hotGridId,
      curGrid: _ctx.curGrid,
      class: "position:absolute",
      onUpdateTicketDetail: _ctx.updateTicketDetail
    }, null, 8, ["ticketModalVisible", "selectOrderCode", "action", "hotGridId", "curGrid", "onUpdateTicketDetail"]),
    _createElementVNode("div", {
      class: _normalizeClass(['detail-bg',_ctx.clickActive ? 'bg-top-active' : 'bg-top'])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(['detail-bg',_ctx.clickActive ? 'bg-bottom-active' : 'bg-bottom'])
    }, null, 2)
  ], 2))
}